import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { FormattedMessage } from 'react-intl';
import CopyBox from '../CopyBox';
import { Tm1Divider } from '../v2';
import copyCorrelationIdMessages from './copy-correlation-id-messages';
import './styles.scss';
const CopyCorrelationId = ({ cid }) => (_jsxs(_Fragment, { children: [_jsx("div", { className: "copy-correlation-id__divider", children: _jsx(Tm1Divider, { orientation: "horizontal" }) }), _jsx(CopyBox, { textToCopy: cid, children: _jsx("div", { className: "copy-box__content", children: _jsx(FormattedMessage, { ...copyCorrelationIdMessages.correlationId, values: { cid } }) }) })] }));
export default CopyCorrelationId;
